import { Component } from '@angular/core';
import { LvrClientReport } from '../../../core/components/client-report/client-report';
import { TranslocoPipe } from '@jsverse/transloco';
import { LvrHeading } from '../../../core/components/heading/heading';
import { LvrButton } from '../../../core/components/lvr-button/lvr-button';
import { LvrSection } from '../../../core/components/section/section';
import { LvrHtmlEditor } from '../../../core/components/html-editor/html-editor';
import { LvrDefaultActions } from '../../../core/components/default-actions/default.actions';
import { MatTooltip } from '@angular/material/tooltip';
import { validateIfIndicatorsAreSet } from '../../../shared/validators/editor-report-indicators.validator';
import { mergeOriginalTemplateWithEditedContent } from '../../../core/components/html-editor/template.func';
import { createErrorNotification, createSuccessNotification } from '../../../shared/notification/notification.factory';

@Component({
	selector: 'lvr-end-qb-report',
	imports: [TranslocoPipe, LvrHeading, LvrButton, LvrSection, LvrHtmlEditor, LvrDefaultActions, MatTooltip],
	templateUrl: './end-qb-report.html',
})
export class LvrEndQbReport extends LvrClientReport {
	private readonly END_QB_REPORT_SAVE_LOADING_KEY = `end-qb-report-${this.assignmentId()}.save`;
	public readonly isLoadingForSaveEndQbReport = this.loading.isCurrentlyLoading(
		this.END_QB_REPORT_SAVE_LOADING_KEY,
		'requestKey',
	);

	public async save() {
		if (!this.canEditReport()) return;

		const uuid = this.loading.setLoadingState(window.crypto.randomUUID(), this.END_QB_REPORT_SAVE_LOADING_KEY);
		const report = this.report()!;
		const template = report.template;

		if (!template) {
			// no template -> no save
			return;
		}

		const content = mergeOriginalTemplateWithEditedContent(template.htmlContent, this.updateHtmlContent());
		const hasIndicators = validateIfIndicatorsAreSet(content);

		try {
			await this.api.updateReportDocument({
				assignmentId: this.assignmentId()!,
				htmlContent: content,
				reportId: report.id,
				isFinal: false,
				isDraft: !hasIndicators,
				reportDocumentTemplateId: template.id,
			});

			await this.navigateAfterFinished(this.getAssignmentDetailsCommands('../..'), {
				relativeTo: this.route,
			});

			this.ntfy.addNotification(
				createSuccessNotification(this.transloco.translate('base.notification_message.save_report_success')),
			);
		} catch {
			this.ntfy.addNotification(
				createErrorNotification(this.transloco.translate('base.notification_message.save_report_error')),
			);
		} finally {
			this.loading.clearLoadingState(uuid);
		}
	}
}
